import { PcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { ContractClassification } from '@/constants/dealer';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type Dealer = {
  autoRenewalPeriod?: number;
  bizType: BizType;
  businessNumber: string;
  classification: string;
  companyName: string;
  contractClassification: ContractClassification;
  id: string;
  isActive: boolean;
  partnerActiveCount: number;
  partnerInactiveCount: number;
  partnerTestCount: number;
};

export const getDealer = (id: string) => {
  return api<PcApiResponse<Dealer>>('get', `/pc-api/v1/${PREFIX_PATH}/dealer`, { id });
};
